import {HttpClient, HttpErrorResponse, HttpParams} from '@angular/common/http';
import {catchError, throwError} from 'rxjs';
import { RuntimeEnvironmentService } from './runtime-environment.service';
import {ToastService} from './toast.service';
import {DataSourceResult} from '../models/data-source/data-source-result.model';
import {DataSourceRequest} from '../models/data-source/data-source-request.model';
import {AuthService} from '@core/services/auth.service';

export abstract class HttpService<T> {
  protected constructor(
    public http: HttpClient,
    private readonly toastService: ToastService,
    private readonly authService: AuthService,
    private readonly runtimeEnv: RuntimeEnvironmentService,
    private readonly path: string,
  ) {
  }

  get(id: number) {
    return this.http.get<T>(this.buildUrl(id))
      .pipe(
        catchError((error) => this.handleError(error))
      );
  }

  all(dataSourceRequest: DataSourceRequest) {
    return this.http.get<DataSourceResult<T>>(this.buildUrl(), {params: this.generateParamsFromDataSourceRequest(dataSourceRequest)})
      .pipe(
        catchError((error) => this.handleError(error))
      );
  }

  update(id: number, body: T) {
    return this.http.put(this.buildUrl(id), body)
      .pipe(
        catchError((error) => this.handleError(error))
      );
  }

  create(body: T) {
    return this.http.post(this.buildUrl(), body)
      .pipe(
        catchError((error) => this.handleError(error))
      );
  }

  delete(id: number) {
    return this.http.delete(this.buildUrl(id))
      .pipe(
        catchError((error) => this.handleError(error))
      );
  }

  generateParamsFromDataSourceRequest(dataSourceRequest: DataSourceRequest) {
    let params = new HttpParams();

    Object.entries(dataSourceRequest)
      .forEach(([key, value]) => params = params.set(key, value))

    return params;
  }

  buildUrl(parameter?: string | number) {
    let url = `${this.runtimeEnv.apiConfig.uri}/${this.path}`;
    console.log(url);

    if (parameter) {
      url += `/${parameter}`;
    }

    return url;
  }

  handleError(error: HttpErrorResponse) {
    console.error('An error occurred:', error.error);

    if (error.status === 0) {
      this.toastService.error('Er kon geen verbinding gemaakt worden met de server, probeer het later opnieuw');
    } else if (error.status === 403) {
      this.toastService.error('U heeft geen toegang tot deze functionaliteit');
      this.authService.unauthorized();
    } else if (error.status !== 400) {
      this.toastService.error('Er is een fout opgetreden, probeer het later opnieuw');
    }

    return throwError(() => error);
  }
}
